import Box from "@mui/material/Box";

import { toDollars } from "../../helpers/currencies";
import { CalculationOutput, GstAmountValues } from "../../types/Calculation";
import APCalculation from "./APCalculation";

const APCalculationOutput = ({
  calculation,
  excludeGst,
}: {
  calculation: CalculationOutput<GstAmountValues>;
  excludeGst?: boolean;
}) => {
  return (
    <Box>
      <APCalculation
        name={`${calculation.name} - Inc GST`}
        value={`${toDollars(calculation.result.incGst, 2)}`}
        tooltip={calculation.formula}
      />
      <APCalculation
        name={`${calculation.name} - Ex GST`}
        value={`${toDollars(calculation.result.exGst, 2)}`}
        tooltip={calculation.formula}
      />
      {!excludeGst && (
        <APCalculation
          name={`${calculation.name} - GST`}
          value={`${toDollars(calculation.result.gst, 2)}`}
          tooltip={calculation.formula}
        />
      )}
    </Box>
  );
};

export default APCalculationOutput;
